import React, { useState } from 'react'
import { useLocation } from 'react-router-dom';
import StoryPopup from './components/StoryPopup'
import { cardStories } from '../../utils/cardStories'

import styles from './AllCards.module.css'

const AllCardsList = () => {

  const { state: {cardOptions} } = useLocation();
  const [visible, setVisible] = useState(false)
  const [currentStory, setCurrentStory] = useState(null)

  const showPopup = (id) => {
    const story = cardStories.find(s => s.id === id)
    setCurrentStory(null)
    setVisible(true)
    setCurrentStory(story)
  }

  const showCheckDetail = (cardStockId) => {
    return cardStories.find(s => s.id === cardStockId)
  }

  return <div className={styles.wrapper}>
    <div className={styles.title}>所有卡片</div>
    {currentStory && <StoryPopup visible={visible} setVisible={setVisible} story={currentStory} />}
    {cardOptions.map((option, index) => <div className={styles['card-box']} key={index}>
      <div className={styles.card}>
       <img src={option.imageUrl} className={styles.img}/>
      </div>
      <div className={styles.right}>
        <div className={styles.name}>{option.styleName}</div>
        <div className={styles.price}>
          <span className={styles['small-text']}>￥</span>
          <span className={styles.price}>{option.price/100}</span>
          <span className={styles['small-text']}>起</span>
        </div>
      </div>
      {option.cardStockId && showCheckDetail(option.cardStockId) && <div className={styles['check-btn']} onClick={() => showPopup(option.cardStockId)}>
        <div className={styles['btn-text']}>查看详情</div>
        <div className={styles.arrow}></div>
      </div>}
    </div>)}
    <div className={styles.more}>想要更多卡片？敬请期待</div>
  </div>
}

export default AllCardsList